import axios from "axios";

class commonService {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    public getProjectVersion() {
        return axios.get('/data/ProjectVersion.json');
    } 
}
export default new commonService;
